<template>
  <v-dialog :value="value" persistent max-width="500" @input="$emit('input', $event)">
    <v-card class="report-months-dialog">
      <div class="report-months-dialog__header">
        <div class="report-months-dialog__icon">
          <v-icon color="primary">mdi-calendar-clock</v-icon>
        </div>
        <div>
          <h2>Choose invoice age</h2>
          <p>Find parents with unpaid invoices at least this old.</p>
        </div>
        <v-spacer />
        <v-btn icon aria-label="Close" @click="close"><v-icon>mdi-close</v-icon></v-btn>
      </div>

      <v-divider />

      <v-card-text class="report-months-dialog__body">
        <v-text-field
          v-model.number="months"
          class="quantity-input"
          type="number"
          min="1"
          max="120"
          step="1"
          outlined
          autofocus
          label="Invoice age in months"
          suffix="months"
          :error-messages="monthErrors"
          :hide-details="monthErrors.length === 0"
          @keydown.enter="createReport"
        />
        <div class="report-months-dialog__hint">
          <v-icon size="19" color="primary">mdi-information-outline</v-icon>
          <span>For example, enter 3 to include open invoices dated three months ago or earlier.</span>
        </div>
      </v-card-text>

      <v-divider />

      <v-card-actions class="report-months-dialog__actions">
        <v-btn text color="grey darken-1" @click="close">Cancel</v-btn>
        <v-btn color="primary" depressed :disabled="monthErrors.length > 0" @click="createReport">
          <v-icon left small>mdi-format-list-bulleted</v-icon>
          View list
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "ReportMonthsSelector",
  props: {
    value: { type: Boolean, default: false },
  },
  data() {
    return { months: 3 };
  },
  computed: {
    monthErrors() {
      if (!Number.isInteger(Number(this.months))) return ["Enter a whole number of months."];
      if (Number(this.months) < 1 || Number(this.months) > 120) return ["Enter a number from 1 to 120."];
      return [];
    },
  },
  watch: {
    value(open) {
      if (open) this.months = 3;
    },
  },
  methods: {
    close() {
      this.$emit("input", false);
    },
    createReport() {
      if (this.monthErrors.length) return;
      this.$emit("submit", Number(this.months));
      this.close();
    },
  },
};
</script>

<style scoped>
.report-months-dialog { border-radius: 14px !important; overflow: hidden; }
.report-months-dialog__header { display: flex; align-items: center; gap: 13px; padding: 20px; }
.report-months-dialog__header h2 { margin: 0; color: #202b3c; font-size: 19px; line-height: 1.3; }
.report-months-dialog__header p { margin: 3px 0 0; color: #748094; font-size: 12px; }
.report-months-dialog__icon { display: flex; flex: 0 0 43px; align-items: center; justify-content: center; width: 43px; height: 43px; border-radius: 11px; background: rgba(25, 118, 210, .08); }
.report-months-dialog__body { padding: 24px; }
.report-months-dialog__hint { display: flex; align-items: flex-start; gap: 9px; margin-top: 14px; padding: 12px 14px; border-radius: 9px; color: #657287; background: #f6f8fb; font-size: 12px; line-height: 1.5; }
.report-months-dialog__actions { justify-content: flex-end; gap: 6px; padding: 14px 20px; }
@media (max-width: 600px) {
  .report-months-dialog__header { padding: 17px 16px; }
  .report-months-dialog__body { padding: 20px 16px; }
}
</style>
